import { useState, useRef } from "react";
import {
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
  DataGrid,
  DatePicker,
  Autocomplete,
} from "../../../../../components";
import { formatDate, formatPrice, responseErros } from "../../../../../utils";
import { value } from "../../../../../helpers";
import { PessoaService } from "../../../../../services";
import { format } from "date-fns";

const pessoaService = new PessoaService();

const OrdemServicoStepperContent = ({
  activeStep,
  setActiveStep,
  buscarOrdensServicos,
  handleAvancarStep,
  handleCancelarImportacao,
  handleImportarOrdemServico,
  servicos,
  servicoSelecionadosIds,
  setServicoSelecionadosIds,
  ordensServicos,
  ordemServicoSelecionadosIds,
  setOrdemServicoSelecionadosIds,
}) => {
  const [filtrosDialog, setFiltrosDialog] = useState({});
  const [listaPessoas, setListaPessoas] = useState([]);
  const [loadingAutoComplete, setLoadingAutoComplete] = useState(false);
  const inputCliente = useRef();
  const colunas = [
    { field: "numeroDocumento", headerName: "Nº Documento", width: 150 },
    { field: "clienteNome", headerName: "Cliente", flex: 400 },
    {
      field: "dataFechamento",
      headerName: "Data Fechamento",
      width: 200,
      valueGetter: (params) =>
        format(formatDate.received(params.value), "dd/MM/yyyy"),
    },
  ];
  const colunasServicos = [
    { field: "codigo", headerName: "Codigo", width: 100 },
    { field: "descricao", headerName: "Descrição", flex: 400 },
    { field: "quantidade", headerName: "Quantidade", flex: 100 },
    {
      field: "valor",
      headerName: "Valor",
      width: 200,
      valueGetter: (params) =>
        params.row.valor ? formatPrice(params.row.valor) : "",
    },
  ];

  const onChangeAutocomplete = (name, value) => {
    setFiltrosDialog({
      ...filtrosDialog,
      [name]: value ? value.id : undefined,
    });
  };

  const handleDateChange = (date, fieldName) => {
    setFiltrosDialog((prevState) => ({
      ...prevState,
      [fieldName]: date != "Invalid Date" ? formatDate.toSend(date) : null,
    }));
  };

  const handleInputChange = (e) => {
    e.persist();
    setFiltrosDialog((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const handleVoltarStep = () => {
    setActiveStep(activeStep - 1);
  };

  const onSearchChangePessoas = async (event, inputRef) => {
    if (event.key === "Enter" && inputRef.current === document.activeElement) {
      const eventValue = event.target?.value;
      let filtros = {
        nomeRazaoSocial: eventValue,
        apelidoFantasia: eventValue,
      };
      setLoadingAutoComplete(true);
      const pessoas = await buscarPessoas(filtros);
      setLoadingAutoComplete(false);
      setListaPessoas(pessoas);
    }
  };

  const buscarPessoas = async (filtros) => {
    const filtro = {
      ...filtros,
      ativado: true,
    };
    const res = await pessoaService.getAll(filtro);
    if (!res.isAxiosError) {
      return res.data.rows;
    } else {
      responseErros(res);
    }
    return [];
  };

  switch (activeStep) {
    case 1:
      return (
        <>
          <DialogContent>
            <DataGrid
              rows={servicos}
              columns={colunasServicos}
              rowCount={servicos.length}
              checkboxSelection
              selectionModel={servicoSelecionadosIds}
              onRowSelectionModelChange={(selectedIds) => {
                setServicoSelecionadosIds(selectedIds);
              }}
              noFilter
              disableAcoes
              noRowsLabel="Serviços sem impostos no cadastro"
            />
          </DialogContent>
          <DialogActions className="m-3">
            <Button
              onClick={handleCancelarImportacao}
              color="padrao"
              variant="contained"
            >
              Cancelar
            </Button>
            <Button
              onClick={handleVoltarStep}
              color="primary"
              variant="contained"
            >
              <i
                className="ph-fill ph-caret-left"
                style={{ color: "#fff", fontSize: 18 }}
              ></i>
              Anterior
            </Button>
            <Button
              onClick={handleImportarOrdemServico}
              color="primary"
              variant="contained"
            >
              Importar
            </Button>
          </DialogActions>
        </>
      );
    default:
      return (
        <>
          <DialogContent>
            <Grid container spacing={2} className="mt-1 mb-4">
              <Grid item xs={3}>
                <Autocomplete
                  id="clienteId"
                  name="clienteId"
                  options={listaPessoas}
                  autoHighlight
                  getOptionLabel={(option) =>
                    option.nomeRazaoSocial
                      ? `${option.codigo}` + ` - ` + `${option.nomeRazaoSocial}`
                      : ""
                  }
                  loading={loadingAutoComplete}
                  noOptionsText={"Digite e pressione Enter"}
                  loadingText="Carregando"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Cliente"
                      variant={"outlined"}
                      required
                      inputRef={inputCliente}
                      onKeyDown={(e) => onSearchChangePessoas(e, inputCliente)}
                    />
                  )}
                  onChange={(e, value) =>
                    onChangeAutocomplete("clienteId", value)
                  }
                  value={value.autoComplete(
                    listaPessoas,
                    filtrosDialog?.clienteId,
                  )}
                />
              </Grid>
              <Grid item xs={2}>
                <DatePicker
                  id="dataInicial"
                  name="dataInicial"
                  label="Data Fechamento Inicial"
                  format="dd/MM/yyyy"
                  value={
                    filtrosDialog?.dataInicial
                      ? filtrosDialog.dataInicial
                      : null
                  }
                  onChange={(date) => handleDateChange(date, "dataInicial")}
                />
              </Grid>
              <Grid item xs={2}>
                <DatePicker
                  id="dataFinal"
                  name="dataFinal"
                  label="Data Fechamento Final"
                  format="dd/MM/yyyy"
                  value={
                    filtrosDialog?.dataFinal ? filtrosDialog.dataFinal : null
                  }
                  onChange={(date) => handleDateChange(date, "dataFinal")}
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  id="numeroDocumento"
                  name="numeroDocumento"
                  label="Nº do documento"
                  variant="outlined"
                  value={
                    filtrosDialog.numeroDocumento
                      ? filtrosDialog.numeroDocumento
                      : undefined
                  }
                  onChange={handleInputChange}
                  fullWidth
                />
              </Grid>
              <Grid item xs={2} className="d-flex align-items-center">
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  fullWidth
                  sx={{ height: "51px" }}
                  onClick={() => buscarOrdensServicos({ ...filtrosDialog })}
                >
                  <i
                    className="ph-bold ph-magnifying-glass"
                    style={{ color: "#fff", fontSize: 18, marginRight: 10 }}
                  ></i>
                  Buscar
                </Button>
              </Grid>
            </Grid>
            <DataGrid
              rows={ordensServicos}
              columns={colunas}
              checkboxSelection
              selectionModel={ordemServicoSelecionadosIds}
              onRowSelectionModelChange={(selectedIds) => {
                setOrdemServicoSelecionadosIds(selectedIds);
              }}
              disableAcoes
              noFilter
            />
          </DialogContent>
          <DialogActions className="m-3">
            <Button
              onClick={handleCancelarImportacao}
              color="padrao"
              variant="contained"
            >
              Cancelar
            </Button>
            <Button
              onClick={() => handleAvancarStep()}
              color="primary"
              variant="contained"
            >
              Próximo
              <i
                className="ph-fill ph-caret-right"
                style={{ color: "#fff", fontSize: 18 }}
              ></i>
            </Button>
          </DialogActions>
        </>
      );
  }
};

export default OrdemServicoStepperContent;
